import React from 'react'

const Header = (props) => {
    return <div className='header'><p>{props.headerText}</p></div>
}

export default Header